import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/service/api.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state() {
    return {
      customerId: 0,
      // 评估
      eval: {
        // 侧边栏 - 六方成评估
        sideList: []
      },
      // 用户消息
      userMessage: {
        // 消息列表
        message: [],
        // 通知列表
        notice: {}
      },
      // 呼叫状态
      callStatus: null
    }
  },
  mutations: {
    setCustomerId(state, data) {
      state.customerId = data;
    },
    // 侧边栏 - 六方成评估
    async setSideEvalList(state, data) {
			state.eval.sideList = data;
    },
    setUserMessage(state, data) {
        state.userMessage.message = data;
    },
    setUserNotice(state, data) {
        state.userMessage.notice = data;
    },
    setCallStatus(state, value) {
      state.callStatus = value;
    }
  },
  actions: {
    // 侧边栏 - 六方成评估
    async loadSideEvalList({commit, state}, customerId) {
      if (!state.customerId && !customerId) {
        commit('setSideEvalList', []);
        return;
      }
      let res = await api.getCustomerAllEval({customerId: customerId || state.customerId,type:1});
      commit('setSideEvalList', res.data);
    },
    // 加载用户信息数据 - 通知
    async loadUserMessage({commit, state}) {
      let res = await api.getUserMessageList({pageNumber: 1, pageSize: 999});
      if (res.code === 1000) {
        commit('setUserMessage', res.data);
      }
    },
    // 加载用户信息数据 - 消息
    async loadUserNotice({commit, state}) {
      let data = { message:[], notice:[] };
      let res = await api.getUserNoticeList({pageNumber: 1, pageSize: 999});
      if (res.code === 1000) {
        commit('setUserNotice', res.data);
      }
    }
  },
  modules: {
  }
})
